import React from 'react';
import { makeStyles } from '~/UIKit/Style';

const useStyles = makeStyles(() => ({
  ItemCreationSideSectionWrapperContainer: {
    display: 'flex',
    margin: 30,
    width: 300,
    justifyContent: 'flex-end',
  },
}));

interface IItemCreationSideSectionWrapperProps {
  children: React.ReactNode[] | React.ReactNode;
}

export const ItemCreationSideSectionWrapper = ({
  children,
}: IItemCreationSideSectionWrapperProps) => {
  const { classes } = useStyles();

  return <div className={classes.ItemCreationSideSectionWrapperContainer}>{children}</div>;
};
